import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { parallelStructureData, getDataForDifficulty } from '../courses/data/grammar/parallelStructure';

export default function ParallelStructureTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : parallelStructureData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
